export default __webpack_public_path__ + "static/media/profile.713925c2.jpg";